import React from "react";
import Navbar from "../global/Navbar";

const HomeBannerDetails = () => {
  return (
    <div className="w-full flex flex-col justify-center items-center bg-[#101e2b]">
      <Navbar />
      <div className="container flex flex-col gap-4 px-4 lg:px-0 mb-[4rem]">
        <h1 className="sm:text-3xl text-2xl  font-bold text-[#22BEFF] mt-[4rem] mb-[2rem] border-b border-[#22BEFF33] text-center">
          শিক্ষার্থীদের REVIVE ও স্মার্ট শিক্ষা প্রতিষ্ঠান রূপান্তর করা QS
          Academy এর মূল লক্ষ্য
        </h1>

        <p className="text-gray-400 text-xl  text-justify">
          বর্তমান বিশ্বের দ্রুত পরিবর্তনশীল প্রেক্ষাপটে শিক্ষা ব্যবস্থারও
          আধুনিকায়ন অপরিহার্য। শুধু বইপত্র মুখস্থ করে ভালো নম্বর পাওয়া যথেষ্ট
          নয়; শিক্ষার্থীদের হতে হবে চিন্তাশীল, বিশ্লেষণধর্মী ও সমস্যা সমাধানে
          দক্ষ। এই চাহিদা পূরণে QS Academy একটি যুগান্তকারী পদক্ষেপ গ্রহণ
          করেছে—যার মূল লক্ষ্য হলো শিক্ষার্থীদের REVIVE করা এবং প্রথাগত শিক্ষা
          প্রতিষ্ঠানগুলোকে স্মার্ট শিক্ষা প্রতিষ্ঠানে রূপান্তর করা।
        </p>
        <p className="text-gray-400 text-xl text-justify">
          REVIVE Generation বলতে বোঝানো হয় ৭ থেকে ১৬ বছর বয়সী শিক্ষার্থীদের
          একটি সচেতন, কল্পনাশক্তিসম্পন্ন ও প্রযুক্তিনির্ভর প্রজন্ম, যারা উপযুক্ত
          দিকনির্দেশনা ও প্রশিক্ষণের মাধ্যমে সমাজ ও বিশ্বে ইতিবাচক পরিবর্তন আনতে
          সক্ষম। এই প্রজন্মের মানসিক বিকাশ, চিন্তাধারা ও জ্ঞান গঠনে Thought
          Test, Mind Mapping Test এবং Knowledge Mapping পদ্ধতির ব্যবহার শিক্ষার
          একটি কার্যকর রূপ। QS Academy এইসব পদ্ধতির মাধ্যমে শিক্ষার্থীদের চিন্তা
          গঠনের ক্ষমতা, বিশ্লেষণ ক্ষমতা এবং ধারণার গভীরতা বৃদ্ধি করে।
        </p>
        <p className="text-gray-400 text-xl  text-justify">
          একইসাথে, QS Academy-এর আরেকটি মুখ্য উদ্যোগ হলো ট্র্যাডিশনাল শিক্ষা
          প্রতিষ্ঠানগুলোকে স্মার্ট শিক্ষা প্রতিষ্ঠানে রূপান্তর করা। এ লক্ষ্যে QS
          Academy আধুনিক প্রযুক্তি, Outcome-Based OBE শিক্ষা এবং মানচিত্রায়ণমূলক
          শিক্ষাপদ্ধতির মাধ্যমে শিক্ষার্থীদের শেখার প্রক্রিয়াকে জীবন্ত ও কার্যকর
          করে তোলে। পাশাপাশি, ট্রেডিশনাল শিক্ষা প্রতিষ্ঠানগুলোকে স্মার্ট শিক্ষা
          প্রতিষ্ঠানে রূপান্তরের মাধ্যমে শিক্ষক ও প্রশাসনের মধ্যে একটি স্বচ্ছ,
          দক্ষ ও ফলপ্রসূ শিক্ষা পরিবেশ গড়ে তোলে। এর ফলে শিক্ষা হয় আরও
          ইন্টার‌্যাক্টিভ, বাস্তবভিত্তিক ও শিক্ষার্থীকেন্দ্রিক। শিক্ষকরা সহজে
          শিক্ষার্থীর অগ্রগতি পর্যবেক্ষণ করতে পারেন, এবং শিক্ষার্থীর প্রয়োজনে
          ব্যক্তিগত সহায়তা প্রদান করতে পারেন।
        </p>
        <p className="text-gray-400 text-xl text-justify">
          এই রূপান্তরের গুরুত্ব অনস্বীকার্য। এটি শিক্ষাকে শুধু তথ্য দেওয়ার
          মাধ্যম হিসেবে নয়, বরং দক্ষতা ও নৈতিকতা গঠনের একটি প্ল্যাটফর্মে পরিণত
          করে। স্মার্ট শিক্ষাপদ্ধতিতে শিক্ষার্থী শেখে কীভাবে সমস্যা সমাধান করতে
          হয়, দায়িত্ব নিতে হয়, এবং জীবনের বাস্তব চ্যালেঞ্জ মোকাবিলা করতে হয়।
          এর ফলে তারা আত্মবিশ্বাসী ও ভবিষ্যতের জন্য প্রস্তুত হয়ে ওঠে।
        </p>
        <p className="text-gray-400 text-xl  text-justify">
          REVIVE শিক্ষার্থীরা হয়ে ওঠে আত্মবিশ্বাসী,
          বিশ্লেষণধর্মী ও সৃজনশীল। তারা শুধু পরীক্ষায় ভালো ফল করে না, বরং
          বাস্তব জীবনের বিভিন্ন পরিস্থিতিতে যুক্তিভিত্তিক সিদ্ধান্ত নিতে পারে।
          অন্যদিকে, স্মার্ট শিক্ষা প্রতিষ্ঠানগুলো শিক্ষক, অভিভাবক ও
          শিক্ষার্থী—সবার জন্যই একটি স্বচ্ছ, প্রযুক্তিনির্ভর ও মানসম্পন্ন শিক্ষা
          পরিবেশ তৈরি করে।
        </p>
      </div>
    </div>
  );
};

export default HomeBannerDetails;
